// Pro's Sounds library: the Sounds page's Library tab (`features/sounds`, `SoundsLibrary`), the
// brand's voiceovers, sound effects and music, inside Pro's shell (spec
// ui-perf/ui-switch-classic-simple-pro, PR e5b). Composed here: a feature never imports another;
// the composition root may.
import { createRoute, useParams } from "@tanstack/react-router";
import { useState } from "react";

import { NO_SOUNDS_FILTER, SoundsLibrary, type SoundsFilter } from "../features/sounds/SoundsLibrary";
import { ProjectLinkProvider } from "../platform/media/project-link";
import { useProProjectLink } from "./pro-project-link";
import { ProPage } from "../features/studio2/ProPage";
import { studio2Route } from "../features/studio2/routes";

/** `pro/sounds`: the brand's sounds, searched, filtered and played as on the Sounds page. */
export const studio2SoundsRoute = createRoute({
  getParentRoute: () => studio2Route,
  path: "sounds",
  component: ProSounds,
});

function ProSounds() {
  const { teamId, brandId } = useParams({
    from: "/signed-in/teams/$teamId/brands/$brandId/studio/pro/sounds",
  });
  // A sound's file menu opens its project in Pro, as the Library's files do (the #1476 review).
  const projectLink = useProProjectLink(teamId, brandId);
  return (
    <ProPage title="Sounds library" lede="The brand's voiceovers, sound effects and music.">
      <ProjectLinkProvider link={projectLink}>
        {/* Another brand starts the library anew, its filter with it. */}
        <BrandSounds key={`${teamId} ${brandId}`} teamId={teamId} brandId={brandId} />
      </ProjectLinkProvider>
    </ProPage>
  );
}

function BrandSounds({ teamId, brandId }: { teamId: string; brandId: string }) {
  const [filter, setFilter] = useState<SoundsFilter>(NO_SOUNDS_FILTER);
  return (
    <SoundsLibrary
      teamId={teamId}
      brandId={brandId}
      filter={filter}
      onFilter={(change) => setFilter((current) => ({ ...current, ...change }))}
    />
  );
}
